import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "triangle",
  "use": "triangle-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol viewBox=\"0 0 10 5\" xmlns=\"http://www.w3.org/2000/svg\" id=\"triangle\">\n    <path d=\"M0 0L5 5L10 0H0Z\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol